import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import contactos from '../contactos'
import casos from '../casos'

import axios from '@/plugins/axios'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'cuenta',
    ...crudState(),
    searchCuenta: false,
    filtroBuscar: '',
    allCuentas: [],
    paginationCuentas: {},
    cuentaCaso: {},
    miembrosCuentas: [],
    miembrosCuentasSE: [],
    searchAccountKeep: '',
    storeSearch: '',
    routerSearch: '',
    paginationAccountKeep: {}, // adpv,
    expanded: false
  }),
  getters: {
    ...crudGetters,
    allCuentas: state => state.allCuentas,
    paginationCuentas: state => state.paginationCuentas,
    cuentaCaso: state => state.cuentaCaso,
    filtroBuscar: state => state.filtroBuscar,
    miembrosCuentas: state => state.miembrosCuentas,
    miembrosCuentasSE: state => state.miembrosCuentasSE,
    searchAccountKeep: state => state.searchAccountKeep,
    routerSearch: state => state.routerSearch,
    storeSearch: state => state.storeSearch,
    paginationAccountKeep: state => state.paginationAccountKeep, // adpv
    expanded: state => state.expanded
  },
  mutations: {
    ...crudMutations,
    setSearchCuenta (state, value) {
      state.searchCuenta = value
    },
    setFiltroBuscar (state, value) {
      state.filtroBuscar = value
    },
    setAllCuentas (state, value) {
      state.allCuentas = value
    },
    setPaginationCuentas (state, data) {
      state.paginationCuentas = data
    },
    setCuentaCaso (state, data) {
      state.cuentaCaso = data
    },
    setMiembrosCuentas (state, data) {
      // state.miembrosCuentas = data
      if (data.action === 'add') {
        state.miembrosCuentas = data.value
      } else {
        state.miembrosCuentas.splice(data.value, 1)
      }
    },
    setMiembrosCuentasSE (state, data) {
      // state.miembrosCuentas = data
      if (data.action === 'add') {
        state.miembrosCuentasSE = data.value
      } else {
        state.miembrosCuentasSE.splice(data.value, 1)
      }
    },
    setSearchAccountKeep (state, value) {
      state.searchAccountKeep = value
    },
    setRouterSearch (state, value) {
      state.routerSearch = value
    },
    setStoreSearch (state, value) {
      state.storeSearch = value
    },
    setPaginationAccountKeep (state, value) { // adpv
      state.paginationAccountKeep = value
    },
    setExpand (state, value) {
      state.expanded = value
    }
  },
  actions: {
    ...crudActions,
    async  getAllCuentas ({ commit, state }, params) {
      const force = get(params, 'force', false)
      const query = get(params, 'query', {})

      if (force || !state.fetched || isEmpty(state.all)) {
        commit('setLoading', 1, { root: true })
        try {
          const response = await axios.get(`${state.endpoint}/get`, { params: query })
          const data = get(response, 'data.data', [])
          const pagination = get(response, 'data.pagination', [])
          commit('setLoading', -1, { root: true })
          commit('setAllCuentas', data)
          commit('setPaginationCuentas', pagination)

          return data
        } catch (e) {
          commit('setLoading', -1, { root: true })
          return Promise.reject(e)
        }
      }
    },

    async saveIntegracion ({ dispatch, state }, data) {
      if (state.one.id > 0) {
        return dispatch('updateIntegracion', data)
      } else {
        return dispatch('create')
      }
    },
    async updateIntegracion ({ commit, state }, value) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.put(`${state.endpoint}/upd`, value === 'normal' ? state.one : state.cuentaCaso)
        const data = get(response, 'data.data', {})

        commit('setCuentaCaso', data)
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  },
  modules: {
    contactos,
    casos
  }
}
